import { render } from "./LicenseSummary.vue?vue&type=template&id=5eea794e"
import script from "./LicenseSummary.vue?vue&type=script&lang=js"
export * from "./LicenseSummary.vue?vue&type=script&lang=js"

import "./LicenseSummary.vue?vue&type=style&index=0&id=5eea794e&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__